import { useTranslation } from 'react-i18next';

import { IconNoDataFound } from '@/components/icons';

const NoData = () => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col justify-end gap-10 h-[460px] w-full items-center">
      <IconNoDataFound />
      <div className="flex flex-col items-center">
        <h2 className="text-center text-[#8C8C8C] text-[20px] font-semibold">{t('noData.title')}</h2>
        <h4 className="text-center text-[#8C8C8C] text-[14px] font-normal">{t('noData.subTitle')}</h4>
      </div>
    </div>
  );
};

export default NoData;
